import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import SuccessfullyDunnedPaymentAlert from './alerts/SuccessfullyDunnedPaymentAlert';
import PaymentProperties from './PaymentProperties';
import PaymentHighlightHeader from './PaymentHighlightHeader';
import PaymentSidebarActions from './sidebarActions/PaymentSidebarActions';
import usePaymentHighlightProperties from '../hooks/usePaymentHighlightProperties';
import MaybeExternalPaymentLink from './MaybeExternalPaymentLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentHighlight = ({
  objectId
}) => {
  const {
    data,
    error
  } = usePaymentHighlightProperties(objectId);
  if (error) {
    throw error;
  }
  if (!data) return /*#__PURE__*/_jsx(LoadingSpinner, {
    "data-test-id": "highlight-spinner",
    minHeight: 126,
    grow: true
  });
  const properties = data.crmObject.defaultProperties;
  const paymentIntentId = data.crmObject.paymentIntentId;
  const externalAccountId = data.crmObject.externalAccountId;
  const externalPaymentUrl = data.crmObject.externalPaymentUrl;
  const isAccountEnabled = data.crmObject.isAccountEnabled;
  const successfullyDunnedPaymentObjectId = data.crmObject.successfullyDunnedPaymentObjectId;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [successfullyDunnedPaymentObjectId && /*#__PURE__*/_jsx(SuccessfullyDunnedPaymentAlert, {
      successfullyDunnedPaymentObjectId: successfullyDunnedPaymentObjectId
    }), /*#__PURE__*/_jsx(PaymentSidebarActions, {
      objectId: objectId,
      paymentHighlightDataCrmObject: data.crmObject
    }), /*#__PURE__*/_jsx(PaymentHighlightHeader, {
      objectId: objectId,
      properties: properties
    }), /*#__PURE__*/_jsx(PaymentProperties, {
      objectId: objectId,
      properties: properties,
      isAccountEnabled: isAccountEnabled
    }), /*#__PURE__*/_jsx(MaybeExternalPaymentLink, {
      properties: properties,
      externalAccountId: externalAccountId,
      externalPaymentUrl: externalPaymentUrl,
      paymentIntentId: paymentIntentId
    })]
  });
};
export default PaymentHighlight;